import { SearchOutlined } from '@ant-design/icons';
import { Col, Result, Row, Select, Skeleton, Table } from 'antd';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { T } from 'react-translator-component';

import * as S from './styled';
import { useVoucherTable } from './useVoucherTable';

import { COLORS } from '../../../utils/theme/colors';
import VoucherIcon from '../../atoms/icons/VoucherIcon';
import { Pagination } from '../../molecules/Pagination/Pagination';

const VoucherTable = () => {
  const { vouchers, columns, dataSource, onChangeField, filters } =
    useVoucherTable();

  return (
    <>
      <S.Div>
        <S.Header>
          <S.Title>
            <VoucherIcon
              className='wrapper-icon'
              fill={COLORS.black}
              height={20}
              width={20}
            />
            {T('Vouchers')}
          </S.Title>

          <Link to='/vouchers/create'>
            <S.NewButton
              size='large'
              type='primary'
              icon={
                <VoucherIcon
                  fill={COLORS.white}
                  height={20}
                  width={20}
                  style={{ marginRight: 16 }}
                />
              }
              block
            >
              Criar Voucher
            </S.NewButton>
          </Link>
        </S.Header>

        <Row gutter={8} style={{ marginTop: 24 }}>
          <Col xl={3}>
            <S.Label>Código</S.Label>
            <S.Input
              style={{ borderRadius: 3 }}
              size='large'
              onChange={(event: any) =>
                onChangeField('code', event.target.value)
              }
              value={filters.code}
            />
          </Col>
          <Col xl={4}>
            <S.Label>Nome</S.Label>
            <S.Input
              style={{ borderRadius: 3 }}
              size='large'
              onChange={(event: any) =>
                onChangeField('title', event.target.value)
              }
              value={filters.title}
            />
          </Col>
          <Col xl={6}>
            <S.Label>Descrição</S.Label>
            <S.Input
              style={{ borderRadius: 3 }}
              size='large'
              onChange={(event: any) =>
                onChangeField('description', event.target.value)
              }
              value={filters.description}
            />
          </Col>
          <Col xl={4}>
            <S.Label>Tipo</S.Label>
            <Select
              size='large'
              style={{ width: '100%' }}
              onChange={(kind: string) => onChangeField('kind', kind)}
              value={filters.kind}
            >
              <Select.Option value='PERCENT_RECHARGE'>
                Porcentagem (%)
              </Select.Option>
              <Select.Option value='MONEY_RECHARGE'>Reais (R$)</Select.Option>
              <Select.Option value='KWH_RECHARGE'>
                Quilowatt-hora (kWh)
              </Select.Option>
            </Select>
          </Col>
          <Col xl={3}>
            <S.Label>Status</S.Label>
            <Select
              size='large'
              style={{ width: '100%' }}
              onChange={(status: string) => onChangeField('status', status)}
              value={filters.status}
            >
              <Select.Option value='NOT_STARTED'>Não iniciado</Select.Option>
              <Select.Option value='ACTIVE'>Ativo</Select.Option>
              <Select.Option value='EXPIRED'>Expirado</Select.Option>
              <Select.Option value='USED'>Usado</Select.Option>
              <Select.Option value='INACTIVE'>Inativo</Select.Option>
            </Select>
          </Col>
          <Col xl={2}>
            <S.Button
              icon={<SearchOutlined />}
              size='large'
              block
              style={{ marginTop: 25 }}
              onClick={() => {
                vouchers.request(
                  vouchers?.pagination?.page,
                  vouchers?.pagination?.pageSize,
                  filters.code,
                  filters.title,
                  filters.description,
                  filters.kind,
                  filters.status,
                );
              }}
            >
              Filtrar
            </S.Button>
          </Col>
          <Col xl={2}>
            <S.Button
              size='large'
              block
              style={{ marginTop: 25 }}
              onClick={() => vouchers.request()}
            >
              Limpar
            </S.Button>
          </Col>
        </Row>

        <S.Listing>
          {vouchers.loading && (
            <Skeleton
              active
              paragraph={{ rows: 18, width: '100%' }}
              title={false}
            />
          )}

          {vouchers.error && (
            <S.Blank>
              <Result
                status='warning'
                title='Não foi possível listar os vouchers!'
                extra={[
                  <S.Button type='primary' key='home'>
                    <Link to='/'>Voltar para a Visão Geral</Link>
                  </S.Button>,
                  <S.Button key='reload' onClick={vouchers.request()}>
                    Tentar novamente
                  </S.Button>,
                ]}
              />
            </S.Blank>
          )}

          {!vouchers.error && !vouchers.loading && (
            <>
              <Table
                columns={columns}
                dataSource={dataSource}
                pagination={false}
              />
              <Pagination
                currentPage={vouchers?.pagination?.page}
                totalCount={vouchers?.data?.count}
                pageSize={vouchers?.pagination?.pageSize}
                onPageChange={(page: number, pageSize: number | undefined) => {
                  vouchers.request(
                    page,
                    pageSize,
                    filters.code,
                    filters.title,
                    filters.description,
                    filters.kind,
                    filters.status,
                  );
                }}
              />
            </>
          )}
        </S.Listing>
      </S.Div>
    </>
  );
};

const mapStateToProps = (state: { user: { routes: any } }) => ({
  routes: state.user.routes,
});

export default connect(mapStateToProps)(VoucherTable);
